/**
 * Paths a signed-out visitor may open; everything else redirects to /Login
 * (middleware/authenticated.global.ts). Whole-path matches, case-insensitive,
 * so `/Login/anything` and `/Claimed` stay protected.
 */
const PUBLIC_ROUTE_PATTERNS: readonly RegExp[] = [/^\/login$/i, /^\/claim$/i]

export function isPublicRoute(path: string): boolean {
  return PUBLIC_ROUTE_PATTERNS.some((pattern) => pattern.test(path))
}
